@if (asset) {
  <ion-grid>
    <ion-row>
      <ion-col style="font-weight: bold; color: var(--ion-color-secondary)"> {{ assetCategory | uppercase }}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col style="padding-top: 0px; min-height: 24px">
        @if (asset.label) {
          <span>{{ asset.label }} </span>
        }
        <span style="font-weight: bold" [innerHTML]="asset.name"></span>
      </ion-col>
    </ion-row>
    @if (formGroup) {
      <form [formGroup]="formGroup">
        @if (asset.iconPositions) {
          <ion-row>
            <ion-col>
              <ion-grid formArrayName="iconPositions">
                <ion-row>
                  <ion-col class="ion-no-padding">Icon-Koordinaten: </ion-col>
                </ion-row>
                @for (iconPos of iconPositionInputs.controls; track iconPos; let i = $index) {
                  <ion-row
                    [ngClass]="{ 'sis-selected-icon-row': selectedIconIndex === i }"
                    [formGroup]="iconPos"
                    >
                    <ion-col size="1">
                      <label>x: </label>
                    </ion-col>
                    <ion-col size="4">
                      <input [ngClass]="{ 'sis-input-error': iconPos.get('x').errors }" type="text" formControlName="x" />
                    </ion-col>
                    <ion-col size="1">
                      <label>y: </label>
                    </ion-col>
                    <ion-col size="4">
                      <input [ngClass]="{ 'sis-input-error': iconPos.get('y').errors }" type="text" formControlName="y" />
                    </ion-col>
                    <ion-col size="1" class="sis-editor-icon">
                      @if (i <= originalAssetMaxIconPositionIndex) {
                        <ion-icon
                          name="return-up-back-outline"
                          (click)="resetPosition(i)"
                          >
                        </ion-icon>
                      }
                    </ion-col>
                    @if (canRemoveIcon) {
                      <ion-col size="1" class="sis-editor-icon">
                        <ion-icon name="trash-outline" (click)="removePosition(i)"> </ion-icon>
                      </ion-col>
                    }
                  </ion-row>
                }
                @if (!maxIconCountReached) {
                  <ion-row class="ion-no-padding">
                    <ion-col style="padding-left: 0">
                      <sis-general-button
                        [btnAlign]="'Left'"
                        [btnType]="'Secondary'"
                        width="50px"
                        text="+"
                        (sisClick)="addPosition()"
                      ></sis-general-button>
                    </ion-col>
                  </ion-row>
                }
              </ion-grid>
            </ion-col>
          </ion-row>
        }
        @for (property of config.editableProperties; track property) {
          <ion-row>
            <ion-col size="4" style="margin: auto"> {{ property.key }}: </ion-col>
            <ion-col>
              @if (property.key !== 'path' && !property.selectableValues) {
                <input
                  type="text"
                  [formControlName]="property.key"
                  style="width: 100%"
                  [ngClass]="{ 'sis-input-error': formGroup.controls[property.key].status === 'INVALID' }"
                  />
              }
              @if (property.key !== 'path' && property.selectableValues) {
                <select
                  [formControlName]="property.key"
                  style="width: 100%"
                  [ngClass]="{ 'sis-input-error': formGroup.controls[property.key].status === 'INVALID' }"
                  >
                  @for (value of property.selectableValues; track value) {
                    <option [value]="value">{{ value }}</option>
                  }
                </select>
              }
              @if (property.key === 'path') {
                <textarea
                  rows="8"
                  [formControlName]="property.key"
                  [ngClass]="{ 'sis-input-error': formGroup.errors?.path }"
                  style="width: 100%; font-size: 12px"
                ></textarea>
              }
            </ion-col>
            <ion-col size="1" class="sis-editor-icon">
              <ion-icon name="return-up-back-outline" (click)="resetProperty(property.key)"> </ion-icon>
            </ion-col>
          </ion-row>
        }
      </form>
    }
    <ion-row class="sis-button-row">
      <ion-col size="4">
        <sis-general-button
          text="general.term.delete"
          expand="block"
          btnAlign="Left"
          btnType="Red"
          (sisClick)="delete()"
          width="100%"
          >
        </sis-general-button>
      </ion-col>
      <ion-col size="4">
        @if (canBeDuplicated) {
          <sis-general-button
            text="general.term.duplicate"
            expand="block"
            btnAlign="Left"
            btnType="Secondary"
            (sisClick)="duplicate()"
            width="100%"
            >
          </sis-general-button>
        }
      </ion-col>
      <ion-col size="4">
        <sis-general-button
          text="general.term.reset"
          expand="block"
          btnAlign="Right"
          [disabled]="!hasChanges"
          btnType="Secondary"
          (sisClick)="reset()"
          width="100%"
          >
        </sis-general-button>
      </ion-col>
    </ion-row>
  </ion-grid>
}
@if (!asset) {
  <div style="padding: 10px">Nichts ausgewählt</div>
}
